 const community_recipes = (state = null, action) => {
    const { type, payload } = action

    switch (type) {
        case 'FETCH_COMMUNITY_RECIPES_SUCCESS':
          return {
            ...state,
            ...payload.community_recipes
          }
        case 'FETCH_COMMUNITY_RECIPES_FAIL':
          return {
            ...state,
          }
        default:
          return state
      }
}

export default community_recipes